import { createClient, type SupabaseClient } from '@supabase/supabase-js';
import { quietNavigatorLock, supportsNavigatorLocks } from './supabaseLock';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Missing Supabase environment variables');
}

// Vite HMR re-evaluates this module on every edit. Without a cached instance
// each reload builds another GoTrueClient that contends with the previous one
// for the same Navigator LockManager lock ("Multiple GoTrueClient instances").
const globalRef = globalThis as typeof globalThis & {
  __dialupSupabase?: SupabaseClient;
};

export const supabase: SupabaseClient =
  globalRef.__dialupSupabase ??
  createClient(supabaseUrl, supabaseAnonKey, {
    auth: {
      persistSession: true,
      autoRefreshToken: true,
      detectSessionInUrl: true,
      // Keeps cross-tab locking, minus the spurious unhandled rejection the
      // stock Navigator LockManager lock logs whenever the lock is busy.
      ...(supportsNavigatorLocks() ? { lock: quietNavigatorLock } : {}),
    },
  });

globalRef.__dialupSupabase = supabase;
